import * as React from "react";

import { Input as PrimitiveInput } from "../../primitive/input";

export type InputProps = React.ComponentProps<typeof PrimitiveInput>;

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (props, ref) => {
    return <PrimitiveInput ref={ref} {...props} />;
  },
);

Input.displayName = "Input";
